import barChartConfig from '../../chartConfigs/barChartConfig';
import Chart from 'chart.js/auto';

const initializeBarChart = (barChart: HTMLCanvasElement, chartId: string) => {
    //const barChart = document.getElementById('bar-chart') as HTMLCanvasElement;

    const barChartCtx = barChart.getContext('2d');

    const gradientOne = barChartCtx.createLinearGradient(0, 0, 800, 0);
    gradientOne.addColorStop(0, barChart.dataset.gradientStart);
    gradientOne.addColorStop(1, barChart.dataset.gradientEnd);

    const chart = new Chart(
        barChartCtx,
        barChartConfig({
            data: window[`barChart_${chartId}`],
            backgroundColor: gradientOne,
            borderColor: barChart.dataset.gradientEnd,
        })
    );
};

export default initializeBarChart;
